import Environment from "../../environment";

import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useStore, useStorePersist } from "store/context";

import { isMobile } from 'helpers/Mobile';
import useRequest from '../../hooks/useRequest';
import {useQuery} from 'hooks/useQuery';
import numberFormatter from 'hooks/numberFormatter';

import MainLayout from '../../components/Layouts/MainLayout';

import SearchSelect from '../../components/atoms/SearchSelect';
import Box from '../../components/atoms/Box';
import GradientButton from '../../components/atoms/GradientButton';
import InputText from 'components/atoms/InputText';
import InputCheckbox from 'components/atoms/InputCheckbox';
import Modal from '../../components/atoms/Modal';
import Situacion from 'components/atoms/Situacion';
import Radio from 'react-bootstrap/FormCheck';

import { FacturaService } from '../../services/FacturaService';
import { UnidadService } from '../../services/UnidadService';

import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import Form from 'react-bootstrap/Form';

import pagoOnline from 'assets/images/pago-online.png';
import redesConfianza from 'assets/images/redes-confianza.png';
import entidadesBancarias from 'assets/images/entidades-bancarias.png';
import credito from 'assets/images/credito.png';
import debito from 'assets/images/debito.png';
import debitoAutomatico from 'assets/images/debito-automatico.png';
import check from 'assets/images/check.png';

import './styles.scss';

const HomeView = (props) => {
  const history = useHistory();
  const {
    currency
  } = numberFormatter();

  const {
    submitted, success, message, errors, loadingSpinner,
    beforeSubmit, afterSubmit, showSuccess, showError,
    dealWithError
  } = useRequest();

  const query = useQuery();
  
  const [load, setLoad] = useStore(false);  // Esta variable sirve para cultar el front hasta tener la unidad.
  const [{
    uf,  // La uf actual seleccionada
    facturasLastUf,  // La uf a la que pertenecen las facturas cargadas
    facturas,  // El listado de facturas
  }, dispatch] = useStore();

  const [{
    unidades
  }, dispatchPersist] = useStorePersist();

  const [modoFD, setModoFD] = useState(1);  // 1=Adherir, 2=Dar de Baja, 3=Confirmar Dar de Baja
  const titleFactura = <>
    <strong>UF</strong> {uf.unidad} - {uf.alias} -
  </>;

  const titleDebito = <>
    <strong>UF</strong> {uf.unidad} - {uf.alias}
  </>;

  const [motivo, setMotivo] = useState("RECIBIR");
  const [comentario, setComentario] = useState("");

  const [importeTotal, setImporteTotal] = useState([]);
  const [deudaVencida, setDeudaVencida] = useState([]);
  const [deudaAVencer, setDeudaAVencer] = useState([]);
  const [ultimaFactura, setUltimaFactura] = useState({"ajustado": 0.00});

  const [showFD, setShowFD] = useState(false);
  const [showDA, setShowDA] = useState(false);
  const [showBajaDA, setShowBajaDA] = useState(false);
  const [showConfirmarBajaDA, setShowConfirmarBajaDA] = useState(false);

  const [hasAdherir, setHasAdherir] = useState();
  const [hasBaja, setHasBaja] = useState();
  const [checkDebitoFactura, setCheckDebitoFactura] = useState(true);
  const [checkDebitoPlan, setCheckDebitoPlan] = useState(true);
  const [hasDebitoPlan, setHasDebitoPlan] = useState();
  const [disableDebitoPlan, setDisableDebitoPlan] = useState();
  const [disableDebitoFactura, setDisableDebitoFactura] = useState();
  const [checkDebitoRadio, setCheckDebitoRadio] = useState();
  const [debitoFactura, setDebitoFactura] = useState(false);
  const [debitoPlan, setDebitoPlan] = useState(false);
  
  useEffect(() => {
    if (!unidades || unidades.length === 0) {
      getUnidades();
    } else {
      setLoad(true);
      if(uf){
        UnidadService.estadoDebito(uf.id).then(data => {
          const missOne = !(data['debito_fac'] && data['debito_plan']);
          setCheckDebitoRadio(missOne);
          setHasBaja(data['debito_fac'] || data['debito_plan']);
          setHasAdherir(missOne);
          setHasDebitoPlan(data['has_plan'])
          updateDisabledDebito(data);
        }).catch((error) => {
          afterSubmit();
          dealWithError(error, '');
        });
      }
    }
    setMotivo("RECIBIR");
  }, []);


  const getUnidades = () => {
    beforeSubmit();
    UnidadService.unidades({})
      .then((unidades) => {
        afterSubmit();
        if (unidades.length === 0) {
          history.push('/unidades_adheridas');
          return;
        }

        dispatchPersist({
          type: 'setUnidades',
          payload: unidades,
        });
        setLoad(true);
      }).catch((error) => {
        afterSubmit();
      });
  }
  
  useEffect(() => {
    if (unidades && unidades.length > 0 && !uf) {
      dispatch({
        type: 'setUf',
        payload: unidades[0],
      });
    }
  }, [unidades]);

  useEffect(() => {
    if (!uf || uf === facturasLastUf) {
      return;
    }

    if (facturasLastUf && uf){
      if (facturasLastUf.unidad === uf.unidad){
        return;
      }
    }
    
    beforeSubmit();

    let fechaHoy = new Date();
    let hoy = formatDate(fechaHoy);
    fechaHoy.setFullYear(fechaHoy.getFullYear() + 1);
    let vto = formatDate(fechaHoy);
    const data = {
      fecha_emi: hoy,
      fecha_vto: vto,
    }

    FacturaService.comprobantes(uf.unidad, data)
      .then(data => {
        dispatch({
          type: 'setFacturas',
          payload: data,
        });
        dispatch({
          type: 'setFacturasLastUf',
          payload: uf,
        });
        UnidadService.estadoDebito(uf.id).then(data => {
          const missOne = !(data['debito_fac'] && (data['debito_plan'] || data['has_plan']));
          setCheckDebitoRadio(missOne);
          setHasBaja(data['debito_fac'] || data['debito_plan']);
          setHasAdherir(missOne);
          setHasDebitoPlan(data['has_plan'])
          updateDisabledDebito(data);
          afterSubmit();
        }).catch((error) => {
          afterSubmit();
          dealWithError(error, '');
        });
      }).catch((error) => {
        afterSubmit();
        console.log('No hay comprobantes');
        dispatch({
          type: 'setFacturas',
          payload: [],
        });
        dispatch({
          type: 'setFacturasLastUf',
          payload: {},
        });
        dealWithError(error, 'Error al obtener comprobantes');
      });
  }, [uf]);

  useEffect(() => {
    if (facturas.length > 0.00) {
      setImporteTotal(facturas.reduce(function (prev, current) {
        if (current.visible && current.seleccionable) {
            return prev + +current.ajustado
        } else {
          return prev + +0.00
        }
      }, 0.00));
      
      setDeudaVencida(facturas.reduce(function (prev, current) {
          if (current.visible && current.estado === 'Vencida' && current.seleccionable) {
            return prev + +current.ajustado
          } else {
            return prev + +0.00
          }
      }, 0.00));

      setDeudaAVencer(facturas.reduce(function (prev, current) {
          if (current.visible && current.estado !== 'Vencida' && current.seleccionable) {
            return prev + +current.ajustado
          } else {
            return prev + +0.00
          }
      }, 0.00));

      let facturasFC = facturas.filter(function (factura) {
        return factura.tpo_com === "FC";
      });
      facturasFC.reverse();
      if (facturasFC.length === 0){
        setUltimaFactura(
          {
            'fec_ven' : '-',
            'ajustado' : 0,
            's_periodo' : '-',
            'comprobante' : '-'
          }
        );
      } else {
        setUltimaFactura(facturasFC[0]);
      }
    } else {
      setImporteTotal('0');
      setDeudaVencida('0');
      setDeudaAVencer('0');
      setUltimaFactura(
        {
          'fec_ven': '-',
          'ajustado': 0,
          's_periodo': '-',
          'comprobante': '-'
        }
      );
    }
  }, [facturas]);

  const handleAdherirFD = () => {
    beforeSubmit();

    FacturaService.adherirFD(uf.id)
      .then(data => {
        afterSubmit();
        dispatch({
          type: 'setUf',
          payload: data,
        });
        handleCloseFD();
      }).catch((error) => {
        afterSubmit();
        dealWithError(error, '');
        //
        // MOSTRAR ERROR
        //
      });
  }

  const handleBajaFD = () => {
    setModoFD(3);
    setMotivo("RECIBIR");  //Setear el default
    setComentario("");  //Setear el default
  }

  const handleConfirmarBajaFD = () => {
    setModoFD(4);
  }

  const handleSubmitConfirmBajaFD = (e) => {
    e.preventDefault();
    const data = {
      motivo: motivo,
      comentario: comentario
    }

    beforeSubmit();
    FacturaService.bajaFD(uf.id, data)
      .then(data => {
        afterSubmit();
        dispatch({
          type: 'setUf',
          payload: data,
        });
        handleCloseFD();
      }).catch((error) => {
        afterSubmit();
        dealWithError(error, '');
        //
        // MOSTRAR ERROR
        //
      });
  }

  const handleShowFD = () => {
    setModoFD(uf.factura_digital ? 2 : 1);
    setShowFD(true);
  }

  const action = () => {
    console.log('action');
  }

  const descargarFactura = () => {
    console.log('action');
  }

   const onCheckPlanChange = () => {
      setCheckDebitoPlan(!checkDebitoPlan);
  }

  const onCheckFacturaChange = () => {
      setCheckDebitoFactura(!checkDebitoFactura);
  }

  const onDebitoChange = () => {
    setDisableDebitoFactura(!disableDebitoFactura);
    setDisableDebitoPlan(!disableDebitoPlan || !hasDebitoPlan);
    setCheckDebitoRadio(!checkDebitoRadio);
    setCheckDebitoFactura(false);
    setCheckDebitoPlan(false);
  }

  const updateDisabledDebito = (data) => {
    const adherirSelected = !(data['debito_fac'] && (data['debito_plan'] || !data['has_plan']));
    console.log(adherirSelected);
    setDebitoFactura(data['debito_fac']);
    setDebitoPlan(data['debito_plan']);
    if(adherirSelected){
      console.log("adehrir");
      setDisableDebitoFactura(data['debito_fac']);
      setDisableDebitoPlan(!data['has_plan'] || data['debito_plan']);
    }
    else{
      console.log("dar de baja");
      setDisableDebitoFactura(!data['debito_fac']);
      setDisableDebitoPlan(!data['has_plan'] || !data['debito_plan']);
    }
  }

  const handleShowDA = () => {
    UnidadService.estadoDebito(uf.id).then(data =>{
      const missOne = !(data['debito_fac'] && (data['debito_plan'] || !data['has_plan']));
      setCheckDebitoRadio(missOne);
      setHasBaja(data['debito_fac'] || data['debito_plan']);
      setHasAdherir(missOne);
      setHasDebitoPlan(data['has_plan'])
      updateDisabledDebito(data);
    }).catch((error) => {
      afterSubmit();
      dealWithError(error, '');
    });
    setShowDA(true);
  }

  const handleDebitoAutomatico = () => {
      if(!checkDebitoFactura && !checkDebitoPlan){
          alert("No se puede adherir");
      }
      else{
          if(checkDebitoRadio){
              const debitoFactura = (checkDebitoFactura && !disableDebitoFactura) ? 1 : 0;
              const debitoPlan = (checkDebitoPlan && !disableDebitoPlan) ? 2 : 0;
              const ambosDebitos = debitoFactura + debitoPlan;
              history.push('/alta-debito/'+uf.id+'/'+ambosDebitos);
          }
          else{
              handleCloseDA();
              setShowBajaDA(true);
              setMotivo("tarjeta_incorrecta");  //Setear el default
              setComentario("");  //Setear el default
          }
      }
  }

  const handleDebitoBaja = (e) => {
    e.preventDefault();
    beforeSubmit();
    const debitoFactura = (checkDebitoFactura && !disableDebitoFactura) ? 1 : 0;
    const debitoPlan = (checkDebitoPlan && !disableDebitoPlan) ? 2 : 0;
    const data = {
      campo: debitoFactura + debitoPlan,
      motivo: motivo,
      comentario: comentario
    }
    UnidadService.bajaDebito(data, uf.id)
        .then(data => {
          afterSubmit();
          handleCloseDA();
          handleCloseBajaDA();
          setShowConfirmarBajaDA(true);
          UnidadService.estadoDebito(uf.id).then(data => {
            const missOne = !(data['debito_fac'] && (data['debito_plan'] || !data['has_plan']));
            setCheckDebitoRadio(missOne);
            setHasBaja(data['debito_fac'] || data['debito_plan']);
            setHasAdherir(missOne);
            setHasDebitoPlan(data['has_plan'])
            updateDisabledDebito(data);
          }).catch((error) => {
            afterSubmit();
            dealWithError(error, '');
          });
    }).catch((error) => {
          dealWithError(error, '');
    });
  }

  const handleCloseFD = () => {
    setShowFD(false);
  }

  const handleCloseDA = () => {
    setShowDA(false);
  }

  const handleCloseBajaDA = () => {
      setShowBajaDA(false);
  }

  const handleCloseConfirmarBajaDA = () => {
    setShowConfirmarBajaDA(false);
  }

  const handleChange = (nroUnidad) => {
    const filtrada = unidades.find(filtrada => filtrada.unidad === nroUnidad);
    UnidadService.unidad(filtrada.id)
      .then(data => {
        afterSubmit();
        dispatch({
          type: 'setUf',
          payload: data,
        });
      }).catch((error) => {
        dealWithError(error, '');
      });
  };

  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  const bodyFDAdherir = <span className="adherir-body">
    <h3>FACTURA DIGITAL</h3>
    {uf.factura_digital &&
      <span className="adherido">ADHERIDO <img src={check}></img></span>}
    {!uf.factura_digital &&
      <span className="no-adherido">NO ADHERIDO</span>}
    <GradientButton legend={'ADHERIR'} handleClick={handleAdherirFD} />
  </span>;

  const bodyFDBaja = <span className="baja-body">
    <h3>BAJA FACTURA DIGITAL</h3>
    {uf.factura_digital &&
      <span className="adherido">ADHERIDO <img src={check}></img></span>}
    {!uf.factura_digital &&
      <span className="no-adherido">NO ADHERIDO</span>}
    <GradientButton legend={'DAR DE BAJA'} handleClick={handleBajaFD} />
  </span>;

  const bodyFDMotivoBaja = <span className="confirmar-baja-body">
    <h3>BAJA FACTURA DIGITAL</h3>
    <div className="confirmar-baja-container">
      <div className="confirmar-baja-content">
        <form className="confirmar-baja-form" onSubmit={handleConfirmarBajaFD}>
          <div className="confirmar-baja-input-group">
            <div className="confirmar-baja-input-container">
              <span>
                <div class="input-text-container">
                  <Form.Group controlId="dropdown-uf-select">
                    <Form.Label>MOTIVO</Form.Label>
                    <Form.Control as="select" size="lg" custom value={motivo}
                      onChange={(event) => { setMotivo(event.target.value) }} >
                        <option key={"RECIBIR"} value="RECIBIR">Deseo Recibir Factura Papel</option>
                        <option key={"VENTA"} value="VENTA">Venta de la Propiedad</option>
                        <option key={"VISUALIZAR"} value="VISUALIZAR">La factura me llega pero no la puedo visualizar</option>
                        <option key={"NOLLEGA"} value="NOLLEGA">No me llega la Factura a mi correo electrónico</option>
                        <option key={"OTROS"} value="OTROS">Otros</option>
                    </Form.Control>
                  </Form.Group>
                </div>
              </span>
            </div>
          </div>
          <div className="confirmar-baja-input-group">
            <div className="confirmar-baja-input-container">
              {motivo === "OTROS" && <InputText id="comentarios" label="COMENTARIOS" type="text" handleChange={(event) => { setComentario(event.target.value) }} error={errors.comentario} />}
            </div>
          </div>
          {(success === false && message) &&
            <p className="error-messages">{message}</p>
          }
          <div className="confirmar-baja-button">
            <GradientButton legend={'CONTINUAR'} handleClick={handleConfirmarBajaFD} />
          </div>
        </form>
      </div>
    </div>
  </span>;

  const bodyFDConfirmBaja = <span className="confirmar-baja-body">
    <h3>FACTURA DIGITAL</h3>
    <div className="confirmar-baja-container">
      <div className="confirmar-baja-content baja-confirmar">
          <span className="adherido">ADHERIDO <img src={check}></img></span>

          <p className="confirmar-baja-mensaje">¿Realmente querés dar de baja la Factura Digital?</p>
          {(success === false && message) &&
            <p className="error-messages">{message}</p>
          }
          <div className="confirmar-baja-button">
            <GradientButton legend={'DAR DE BAJA'} handleClick={handleSubmitConfirmBajaFD} />
          </div>
      </div>
    </div>
  </span>;

    const bodyDebito = <span className="adherir-debito-body">
    <h3>DÉBITO AUTOMÁTICO</h3>
        <Radio inline name="debitoOperacion" type='radio' onClick={onDebitoChange} checked={checkDebitoRadio} label='Adherir' id="debito-adherir" disabled={!hasAdherir}/>
        <Radio inline name="debitoOperacion" type='radio' onClick={onDebitoChange} checked={!checkDebitoRadio} label='Dar de baja' id="debito-plan" disabled={!hasBaja}/>
        <InputCheckbox checked={(checkDebitoFactura || disableDebitoFactura)} handleChange={onCheckFacturaChange} legend={'Factura'} value={'F'} disabled={disableDebitoFactura}/>
        <InputCheckbox checked={(checkDebitoPlan || disableDebitoPlan)} handleChange={onCheckPlanChange} legend={'Plan de Financiación'} value={'P'} disabled={disableDebitoPlan}/>
        <GradientButton legend={'CONTINUAR'} handleClick={handleDebitoAutomatico} disabled={!(checkDebitoFactura && checkDebitoFactura)}/>
  </span>;

    const bodyBajaDebito = <span className="confirmar-baja-body">
      <h3>BAJA DÉBITO AUTOMÁTICO</h3>
      <div className="confirmar-baja-container">
        <div className="confirmar-baja-content">
          <form className="confirmar-baja-form" onSubmit={handleDebitoBaja}>
            <div className="confirmar-baja-input-group">
              <div className="confirmar-baja-input-container">
                <span>
                  <div className="input-text-container">
                    <Form.Group controlId="dropdown-motivo-select">
                      <Form.Label>MOTIVO</Form.Label>
                      <Form.Control as="select" size="lg" custom onChange={(event) => {setMotivo(event.target.value)}}>
                        <option key={"TARJETA_INCORRECTA"} value="TARJETA_INCORRECTA">Número de tarjeta o cuenta incorrecto</option>
                        <option key={"TARJETA_BAJA"} value="TARJETA_BAJA">Tarjeta o cuenta dada de baja</option>
                        <option key={"TARJETA_INHABILITADA"} value="TARJETA_INHABILITADA">Tarjeta o cuenta inhabilitada</option>
                        <option key={"CUENTA_CERRADA"} value="CUENTA_CERRADA">Cuenta cerrada</option>
                        <option key={"OTROS"} value="OTROS">Otros</option>
                      </Form.Control>
                    </Form.Group>
                  </div>
                </span>
              </div>
            </div>
            <div className="confirmar-baja-input-group">
              <div className="confirmar-baja-input-container">
                {motivo === "OTROS" && <InputText id="comentarios" label="COMENTARIOS" type="text" handleChange={(event) => { setComentario(event.target.value) }} error={errors.comentario} />}
              </div>
            </div>
            {(success === false && message) &&
              <p className="error-messages">{message}</p>
            }
            <div className="confirmar-baja-button">
              <GradientButton legend={'DAR DE BAJA'} handleClick={handleDebitoBaja} />
            </div>
          </form>
        </div>
      </div>
    </span>;

  const bodyConfirmarBajaDebito = <span className="confirmar-baja-body">
    <h3>DÉBITO AUTOMÁTICO</h3>
    <div className="confirmar-baja-container">
      <div className="confirmar-baja-content baja-confirmar">

        {(checkDebitoFactura && !checkDebitoPlan) && <p className="confirmar-baja-mensaje">La Unidad fue dada de baja al débito automático de facturas.</p>}
        {(!checkDebitoFactura && checkDebitoPlan) && <p className="confirmar-baja-mensaje">La Unidad fue dada de baja al débito automático de planes de financiación.</p>}
        {(checkDebitoFactura && checkDebitoPlan) && <p className="confirmar-baja-mensaje">La Unidad fue dada de baja al débito automático de facturas y planes de financiación.</p>}

        <div className="confirmar-baja-button">
          <GradientButton legend={'CERRAR'} handleClick={handleCloseConfirmarBajaDA} />
        </div>
      </div>
    </div>
  </span>;

  let bodyFD;
  switch (modoFD) {
    case 1:
      bodyFD = bodyFDAdherir;
      break;
    case 2:
      bodyFD = bodyFDBaja;
      break;
    case 3:
      bodyFD = bodyFDMotivoBaja;
      break;
    case 4:
      bodyFD = bodyFDConfirmBaja;
      break;
  }

  /*

  Usar "load" para ocultar todo momentaneamente por si no tiene unidades y hay que redireccionar

  */

  const pagarAhora = (e) => {
    e.preventDefault();
    history.push('/consulta_descarga_facturas?seleccionar=todos');
  }

  const consumo = (e) => {
    e.preventDefault();
    history.push('/consumos');
  }

  return <> <MainLayout>
          {unidades && <SearchSelect onChange={handleChange} options={unidades} value={uf}></SearchSelect>}
          <div className="home-boxes">
            <Box header="DATOS SUMINISTRO" body={<div className="datos-suministros">
            <div className="datos-suministro datos-partida-usuario">
              <div className="partida-usuario">
                  <h4>PARTIDO/PARTIDA</h4>
                  <p>{uf.partido_partida}</p>
              </div>
              <div className="partida-usuario">
                  <h4>TIPO DE USUARIO</h4>
                  <p>Residencial</p>
              </div>
              {!isMobile && <Situacion situacion={uf.situacion} situacionCompleta={uf.situacion_completa}></Situacion>}
            </div>
            <div className="datos-suministro">
              <h4>DATOS DEL USUARIO</h4>
              <h4><strong>{uf.nombre_usuario}</strong></h4>
              <p>{uf.direccion_usuario}</p>
              <p className="direccion"></p>
            </div>
            <div className="datos-suministro">
              <h4>DATOS DEL PROPIETARIO</h4>
              <h4><strong>{uf.razon_social}</strong></h4>
              <p>{uf.direccion}</p>
            </div>
            {isMobile && <Situacion situacion={uf.situacion} situacionCompleta={uf.situacion_completa}></Situacion>}
            <div className="datos-suministro">
              <GradientButton legend={'VER CONSUMO'} handleClick={consumo}/>
            </div>
            </div>} ></Box>
          </div>


      <div className="home-boxes">
              <div className="home-col deuda-col">
                <div className="home-boxes">
                  <Box header="DEUDA" body={
                    <div className="deuda">
                      <div className="deuda-item total">
                        <h4 className="deuda-label">IMPORTE A PAGAR:  
                        <span className="deuda-monto total">{!loadingSpinner && <>$ {currency.format(importeTotal)} </> }</span>
                        </h4>
                      </div>
                      <div className="deudas">
                        <div className="deuda-col">
                          <div className="deuda-item">
                            <p className="deuda-label">Deuda Vencida</p>
                            <p className="deuda-monto vencida">{!loadingSpinner && <>$ {currency.format(deudaVencida)} </>}</p>
                          </div>
                          <div className="deuda-item">
                            <p className="deuda-label">Deuda a Vencer</p>
                            <p className="deuda-monto a-vencer">{!loadingSpinner && <>$ {currency.format(deudaAVencer)} </>}</p>
                          </div>
                        </div>
                        <div className="deuda-button">
                          {(importeTotal > 0.00 && uf.pagable) && <GradientButton legend={'PAGAR AHORA'} handleClick={pagarAhora}/>}
                        </div>
                      </div>
                    </div> 
                  } ></Box>
                  </div>
                  <div className="home-boxes debito-factura">
                      <Box header="DÉBITO AUTOMÁTICO" body={
                        <div className="debito-automatico">
                          <div className="debito-automatico-item">
                            <p className="debito-automatico-label">Facturas</p>
                            {debitoFactura &&
                            <span className="adherido">ADHERIDO <img src={check}></img></span> }
                            {!debitoFactura  &&
                            <span className="no-adherido">NO ADHERIDO</span>}
                          </div>
                          <div className="debito-automatico-item">
                            <p className="debito-automatico-label">Plan de Financiación</p>
                            {debitoPlan &&
                              <span className="adherido">ADHERIDO <img src={check}></img></span>}
                            {!debitoPlan &&
                              <span className="no-adherido">NO ADHERIDO</span>}
                          </div>
                          <div className="debito-automatico-button">
                            <GradientButton legend={'ACCEDER'} handleClick={handleShowDA}/>
                          </div>
                        </div>
                      } ></Box>
                      <Box header="FACTURA DIGITAL" body={
                        <div className="factura-digital">
                          <div className="factura-digital-item">
                            <p className="factura-digital-label">Factura</p>
                            {uf.factura_digital &&
                              <span className="adherido">ADHERIDO <img src={check}></img></span>}
                            {!uf.factura_digital  &&
                              <span className="no-adherido">NO ADHERIDO</span>}
                          </div>
                          <div className="factura-digital-button">
                            <GradientButton legend={'ACCEDER'} handleClick={handleShowFD}/>
                          </div>
                        </div>
                      } ></Box>
                </div>
              </div>
              <div className="home-col ultima-factura">
                <div className="home-boxes">
                  <Box header="ÚLTIMA FACTURA" body={
                    <div className="ultima-factura">
                      <div className="ultima-factura-mobile">
                        <div className="ultima-factura-item">
                          <h4>VENCIMIENTO</h4>
                          <p>{!loadingSpinner && <>{ultimaFactura.fec_ven} </>}</p>
                        </div>
                        <div className="ultima-factura-item">
                            <h4>TOTAL</h4>
                            <p>{!loadingSpinner && <>$ {currency.format(ultimaFactura.ajustado)} </>}</p>
                        </div>
                      </div>
                      <div className="ultima-factura-item">
                          <h4>PERIODO</h4>
                          <p>{!loadingSpinner && <>{ultimaFactura.s_periodo} </>}</p>
                      </div>
                      <div className="ultima-factura-button">
                          { ultimaFactura.comprobante !== '-' && <a target="_blank" href={`${Environment.api}api/unidades-facturaciones/${uf.unidad}/comprobantes/${ultimaFactura.comprobante}/imprimir`} className="descarga">
                          <GradientButton legend={'DESCARGAR'} /> 
                          </a>}
                      </div>
                    </div>
                  } ></Box>
                </div>
              </div>
              <div className="home-col formas-pago">
                  <div className="home-boxes">
                    <Box header="FORMAS DE PAGO" body={
                        <div className="formas-pago-accordion">
                        <Accordion>
                          <Card>
                            <Card.Header>
                              <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                <img src={pagoOnline}></img> PAGO ONLINE
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="0">
                              <Card.Body>
                                <p>VISA Home</p>
                                <p>Link Pagos</p>
                                <p>Pagos Mis Cuentas</p>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                          <Card>
                            <Card.Header>
                              <Accordion.Toggle as={Button} variant="link" eventKey="1">
                                <img src={debito}></img> TARJETA DE DÉBITO
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="1">
                              <Card.Body>
                                <p>VISA Electrón</p>
                                <p>Maestro</p>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                          <Card>
                            <Card.Header>
                              <Accordion.Toggle as={Button} variant="link" eventKey="2">
                                <img src={credito}></img> TARJETA DE CRÉDITO
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="2">
                              <Card.Body>
                                <p>Visa</p>
                                <p>Mastercard</p>
                                <p>American Express</p>
                                <p>Cabal</p>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                          <Card>
                            <Card.Header>
                              <Accordion.Toggle as={Button} variant="link" eventKey="3">
                                <img src={debitoAutomatico}></img> DÉBITO AUTOMÁTICO
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="3">
                              <Card.Body>
                                <p>En tarjeta de crédito</p>
                                <p>En cuenta bancaria</p>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                          <Card>
                            <Card.Header>
                              <Accordion.Toggle as={Button} variant="link" eventKey="4">
                              <img src={entidadesBancarias}></img> ENTIDADES BANCARIAS
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="4">
                              <Card.Body>
                                <p>Banco Credicoop</p>
                                <p>Banco de la Provincia de Buenos Aires</p>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                          <Card>
                            <Card.Header>
                              <Accordion.Toggle as={Button} variant="link" eventKey="5">
                              <img src={redesConfianza}></img> REDES DE COBRANZA
                              </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="5">
                              <Card.Body>
                                <p>Pago Fácil</p>
                                <p>Provincia Net</p>
                                <p>Rapipago</p>
                                <p>Cobro Express</p>
                                <p>Ripsa</p>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </div>
                    } ></Box>
                  </div>
                </div>
        </div>
        </MainLayout>
          <Modal className="modal-factura-digital" title={titleFactura} body={bodyFD} legend={"ACCEDER"} action={action} handleClose={handleCloseFD} show={showFD}></Modal>
          <Modal className="modal-debito-automatico" title={titleDebito} body={bodyDebito} legend={"CONTINUAR"} action={action} handleClose={handleCloseDA} show={showDA}></Modal>
          <Modal className="modal-debito-automatico" title={titleDebito} body={bodyBajaDebito} legend={"DAR DE BAJA"} action={action} handleClose={handleCloseBajaDA} show={showBajaDA}></Modal>
          <Modal className="modal-debito-automatico" title={titleDebito} body={bodyConfirmarBajaDebito} legend={""} action={action} handleClose={handleCloseConfirmarBajaDA} show={showConfirmarBajaDA}></Modal>
        </>;
}

export default withTranslation()(HomeView);